import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
export class FormlyWrapperLabel extends FieldWrapper {
   fieldComponent: ViewContainerRef;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'formly-wrapper-label',
  template: `
    <label [attr.for]="id" class="form-control-label">
      {{ to.label }}
      {{ to.required ? '*' : '' }}
    </label>
    <ng-template #fieldComponent></ng-template>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'fieldComponent': [{ type: ViewChild, args: ['fieldComponent', {read: ViewContainerRef}, ] },],
};
}

function FormlyWrapperLabel_tsickle_Closure_declarations() {
/** @type {?} */
FormlyWrapperLabel.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormlyWrapperLabel.ctorParameters;
/** @type {?} */
FormlyWrapperLabel.propDecorators;
/** @type {?} */
FormlyWrapperLabel.prototype.fieldComponent;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
